// src/pages/About.jsx
import React, { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import CompanyStory from '../components/about/CompanyStory';
import MissionVision from '../components/about/MissionVision';
import CoreValues from '../components/about/CoreValues';
import LeadershipTeam from '../components/about/LeadershipTeam';

const About = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  const missionVision = {
    mission: "To create architectural designs that harmonize human needs with environmental sustainability, using innovative technologies and time-tested principles to build spaces that nurture both people and the planet.",
    vision: "To be the leading architectural firm in sustainable design in South Asia, pioneering solutions that inspire a global shift towards eco-conscious building practices."
  };

  const coreValues = [
    {
      title: "Environmental Stewardship",
      description: "We design with the understanding that our choices impact the planet for generations to come.",
      icon: "🌱"
    },
    {
      title: "Cultural Sensitivity",
      description: "We honor local traditions, materials, and aesthetic sensibilities in our designs.",
      icon: "🏮"
    },
    {
      title: "Innovation",
      description: "We constantly research and implement cutting-edge sustainable technologies and practices.",
      icon: "💡"
    },
    {
      title: "Integrity",
      description: "We maintain transparency in our processes and honesty in our relationships with clients and partners.",
      icon: "🤝"
    }
  ];

  const teamMembers = [
    {
      name: "Aruna Patel",
      position: "Co-Founder & Lead Architect",
      bio: "With over 20 years of experience in sustainable architecture, Aruna brings expertise in passive cooling systems and vernacular design principles.",
      image: "/assets/images/team/founder1.jpg"
    },
    {
      name: "Karthik Reddy",
      position: "Co-Founder & Technical Director",
      bio: "Karthik specializes in sustainable materials and construction technologies, with a background in civil engineering and green building certifications.",
      image: "/assets/images/team/founder2.jpg"
      },
      {
      name: "Deepa Menon",
      position: "Senior Project Architect",
      bio: "Deepa leads our commercial projects division with expertise in LEED certification and biophilic design principles.",
      image: "/assets/images/team/senior-architect.jpg"
      },
      {
      name: "Rohan Desai",
      position: "Sustainable Systems Engineer",
      bio: "Rohan integrates renewable energy systems and water management solutions into our architectural designs.",
      image: "/assets/images/team/systems-engineer.jpg"
      }
      ];
  
      return (
      <Layout>

      {/* <Section className=" py-16 ">
      <div className="container mx-auto px-4">
      <Heading level="h1">About Vasudharini</Heading>
      <p className="text-xl text-gray-600 mt-4 max-w-3xl">
      We are a team of architects, designers, and engineers committed to creating sustainable spaces that honor our planet while meeting human needs.
      </p>
      </div>
      </Section> */}
  
      <div className=''>
      <CompanyStory />
      <MissionVision data={missionVision} />
      <CoreValues values={coreValues} />
      <LeadershipTeam team={teamMembers} />
      </div>
      </Layout>
      );
      };
  
      export default About;